import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_cash_stmt_line_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    hdr_guid: fromDatatype.GuidDataFieldInterface;
    descr: fromDatatype.TextDatatypeInterface;
    remarks: fromDatatype.TextDatatypeInterface;
    txn_date: fromDatatype.TimestampTzDatatypeInterface;
    statement_date: fromDatatype.TimestampTzDatatypeInterface;
    entry_date: fromDatatype.TimestampTzDatatypeInterface;
    post_date: fromDatatype.TimestampTzDatatypeInterface;
    payee_guid: fromDatatype.GuidDataFieldInterface;
    payee_name: fromDatatype.TextDatatypeInterface;
    acc_num: fromDatatype.TextDatatypeInterface;
    amount_debit: fromDatatype.NumericDatatypeInterface;
    amount_credit: fromDatatype.NumericDatatypeInterface;
    balance_amount_debit: fromDatatype.NumericDatatypeInterface;
    balance_amount_credit: fromDatatype.NumericDatatypeInterface;
    txn_amount: fromDatatype.NumericDatatypeInterface;
    txn_type: fromDatatype.VarcharDatatypeInterface;
    open_amount: fromDatatype.NumericDatatypeInterface;
    approval_code: fromDatatype.VarcharDatatypeInterface;
    ref_num: fromDatatype.VarcharDatatypeInterface;
    ref_bank: fromDatatype.VarcharDatatypeInterface;
    ref_cust: fromDatatype.VarcharDatatypeInterface;
    bic: fromDatatype.VarcharDatatypeInterface;
    iban: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    guid_cashbook: fromDatatype.GuidDataFieldInterface;
}

export class bl_fi_cash_stmt_line_RowClass implements bl_fi_cash_stmt_line_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    hdr_guid: fromDatatype.GuidDataFieldInterface;
    descr: fromDatatype.TextDatatypeInterface;
    remarks: fromDatatype.TextDatatypeInterface;
    txn_date: fromDatatype.TimestampTzDatatypeInterface;
    statement_date: fromDatatype.TimestampTzDatatypeInterface;
    entry_date: fromDatatype.TimestampTzDatatypeInterface;
    post_date: fromDatatype.TimestampTzDatatypeInterface;
    payee_guid: fromDatatype.GuidDataFieldInterface;
    payee_name: fromDatatype.TextDatatypeInterface;
    acc_num: fromDatatype.TextDatatypeInterface;
    amount_debit: fromDatatype.NumericDatatypeInterface;
    amount_credit: fromDatatype.NumericDatatypeInterface;
    balance_amount_debit: fromDatatype.NumericDatatypeInterface;
    balance_amount_credit: fromDatatype.NumericDatatypeInterface;
    txn_amount: fromDatatype.NumericDatatypeInterface;
    txn_type: fromDatatype.VarcharDatatypeInterface;
    open_amount: fromDatatype.NumericDatatypeInterface;
    approval_code: fromDatatype.VarcharDatatypeInterface;
    ref_num: fromDatatype.VarcharDatatypeInterface;
    ref_bank: fromDatatype.VarcharDatatypeInterface;
    ref_cust: fromDatatype.VarcharDatatypeInterface;
    bic: fromDatatype.VarcharDatatypeInterface;
    iban: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    guid_cashbook: fromDatatype.GuidDataFieldInterface;
}